import OKPD from "@/assets/okpd.json";

const LETTERS = [
  { code: "A", title: "Продукция сельского, лесного и рыбного хозяйства", top2: ["01","02","03"] },
  { code: "B", title: "Продукция горнодобывающих производств", top2: ["05","06","07","08","09"] },
  { code: "C", title: "Продукция обрабатывающих производств", top2: Array.from({length:24},(_,i)=>String(i+10).padStart(2,"0")) }, // 10..33
  { code: "D", title: "Электроэнергия, газ, пар и кондиционирование воздуха", top2: ["35"] },
  { code: "E", title: "Водоснабжение; водоотведение, услуги по удалению и рекультивации отходов", top2: ["36","37","38","39"] },
  { code: "F", title: "Сооружения и строительные работы", top2: ["41","42","43"] },
  { code: "G", title: "Услуги по оптовой и розничной торговле; услуги по ремонту автотранспортных средств и мотоциклов", top2: ["45","46","47"] },
  { code: "H", title: "Услуги транспорта и складского хозяйства", top2: ["49","50","51","52","53"] },
  { code: "I", title: "Услуги гостиничного хозяйства и общественного питания", top2: ["55","56"] },
  { code: "J", title: "Услуги в области информации и связи", top2: ["58","59","60","61","62","63"] },
  { code: "K", title: "Услуги финансовые и страховые", top2: ["64","65","66"] },
  { code: "L", title: "Услуги, связанные с недвижимым имуществом", top2: ["68"] },
  { code: "M", title: "Услуги, связанные с научной, инженерно-технической и профессиональной деятельностью", top2: ["69","70","71","72","73","74","75"] },
  { code: "N", title: "Услуги административные и вспомогательные", top2: ["77","78","79","80","81","82"] },
  { code: "O", title: "Услуги в сфере государственного управления и обеспечения военной безопасности; услуги по обязательному социальному обеспечению", top2: ["84"] },
  { code: "P", title: "Услуги в области образования", top2: ["85"] },
  { code: "Q", title: "Услуги в области здравоохранения и социальные услуги", top2: ["86","87","88"] },
  { code: "R", title: "Услуги в области искусства, развлечений, отдыха и спорта", top2: ["90","91","92","93"] },
  { code: "S", title: "Услуги общественных организаций; прочие услуги для населения", top2: ["94","95","96"] },
  { code: "T", title: "Товары и услуги домашних хозяйств для собственного потребления", top2: ["97","98"] },
  { code: "U", title: "Услуги, предоставляемые экстерриториальными организациями и органами", top2: ["99"] },
];

const LETTER_BY_TOP2 = new Map(
  LETTERS.flatMap(l => l.top2.map(t2 => [t2, l.code]))
);
const LETTER_TITLE = Object.fromEntries(LETTERS.map(l => [l.code, l.title]));

const REG = new Map();
for (const r of OKPD) {
  REG.set(r.code, { code: r.code, title: r.title, childrenCodes: [] });
}
for (const r of OKPD) {
  if (r.parent && REG.has(r.parent)) REG.get(r.parent).childrenCodes.push(r.code);
}

for (const rec of REG.values()) rec.childrenCodes.sort(numAwareCompare);

const ROOT_LETTERS = LETTERS.map(l => makeNode(l.code, l.title, true));

function makeNode(code, title, hasChildren) {
  return { code, title, hasChildren: !!hasChildren };
}
function cloneFromReg(code) {
  const rec = REG.get(code);
  return makeNode(rec.code, rec.title, rec.childrenCodes.length > 0);
}
function top2Of(code) { return code.split(".")[0]; }



function numAwareCompare(a, b) {
  const pa = a.split(".").map(x => Number(x));
  const pb = b.split(".").map(x => Number(x));
  const L = Math.max(pa.length, pb.length);
  for (let i = 0; i < L; i++) {
    const va = pa[i] ?? -1, vb = pb[i] ?? -1;
    if (va !== vb) return va - vb;
  }
  return 0;
}


export function isLetter(code) {
  return /^[A-Z]$/.test(String(code || ''));
}

export function isNumericOkpd(code) {
  return /^\d/.test(String(code || ''));
}

export function okpdRoots() {
  return ROOT_LETTERS.slice();
}

export function okpdChildren(code) {
  if (isLetter(code)) {
    const letter = LETTERS.find(l => l.code === code);
    if (!letter) return [];
    return letter.top2
      .filter(t2 => REG.has(t2))
      .map(t2 => cloneFromReg(t2));
  }

  const rec = REG.get(code);
  if (!rec) return [];
  return rec.childrenCodes.map(c => cloneFromReg(c));
}

export function okpdSearch(query) {
  const q = String(query || "").trim().toLowerCase();
  if (!q) return okpdRoots();

  const out = [];

  for (const L of LETTERS) {
    if (
      L.code.toLowerCase().includes(q) ||
      (L.title && L.title.toLowerCase().includes(q))
    ) {
      out.push(makeNode(L.code, L.title, true));
    }
  }

  for (const rec of REG.values()) {
    if (
      rec.code.toLowerCase().includes(q) ||
      (rec.title && rec.title.toLowerCase().includes(q))
    ) {
      out.push(makeNode(rec.code, rec.title, rec.childrenCodes.length > 0));
    }
  }

  return out.sort((a, b) => {
    const aIsNum = /^\d/.test(a.code), bIsNum = /^\d/.test(b.code);
    if (aIsNum !== bIsNum) return aIsNum ? -1 : 1;
    if (aIsNum && bIsNum) return numAwareCompare(a.code, b.code);
    return a.code < b.code ? -1 : 1;
  });
}

export function okpdLabel(code) {
  if (isLetter(code)) return `${code}: ${LETTER_TITLE[code] || ""}`;
  const rec = REG.get(String(code));
  return rec ? `${rec.code}: ${rec.title || ""}` : String(code);
}

export function okpdCodeFromLabel(tag) {
  const s = String(tag ?? "").trim();
  const i = s.indexOf(":");
  return (i > 0 ? s.slice(0, i) : s).trim();
}

export function okpdExists(code) {
  const c = String(code ?? '').trim();
  if (!c) return false;
  return isLetter(c) ? true : REG.has(c);
}
